var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoBox"},[_c('div',{staticClass:"prism-player",attrs:{"id":this.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }